module.exports = __webpack_public_path__ + "static/media/18ECA51.1d770f23.jpg";